import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import PageLayout from "./PageLayout";
import { listContent } from "../lib/api";
import { APP_STORE_URL } from "../data/mock";

export default function FaqPage() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    listContent("faqs").then(setFaqs).catch(() => setFaqs([]));
  }, []);
  return (
    <PageLayout
      title="Frequently Asked Questions"
      subtitle="Everything you need to know about sharing your #LifeWithAbba. Can't find what you're looking for? We're happy to help."
    >
      <div className="max-w-3xl mx-auto px-5 py-14 md:py-20">
        {faqs.map((group) => (
          <div key={group.category} className="mb-12">
            <h2 className="font-serif-display text-[#333] text-xl md:text-2xl font-bold mb-4">
              {group.category}
            </h2>
            <Accordion type="single" collapsible className="w-full">
              {group.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`${group.category}-${i}`}
                  className="border-b border-[#e6eef0]"
                >
                  <AccordionTrigger className="font-serif-body text-[#333] text-[16px] md:text-[17px] text-left hover:text-[#68c2d5] hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-serif-body text-[#666] text-[15px] leading-relaxed">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}

        <div className="mt-16 rounded-[10px] border border-[#d7e6ea] px-6 py-10 text-center">
          <p className="font-serif-display text-[#68c2d5] text-xl md:text-2xl font-bold">
            Still have questions?
          </p>
          <p className="font-serif-body text-[#666] text-[15px] mt-3 max-w-md mx-auto">
            Reach out to our team, or download the app and start your journey
            with Abba today.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/#top"
              className="bg-[#0f9fbc] hover:bg-[#008da9] text-white font-serif-body px-6 py-3 rounded-[4px] transition-colors"
            >
              Contact Us
            </Link>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="border border-[#0f9fbc] text-[#0f9fbc] hover:bg-[#0f9fbc] hover:text-white font-serif-body px-6 py-3 rounded-[4px] transition-colors"
            >
              Get The iOS App
            </a>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
